/*=========================================================================================
  File Name: module-mws-getters.js
  Description: MWS Module Getters
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	MWSToken: state => {
		return state.MWSToken;
	},
	/**
	 * Token còn hiệu lực: hết hạn so với thời điểm hiện tại (biên trừ 15% đã tính lúc cache)
	 */
	hasValidToken: state => {
		return !!(
			state.MWSToken &&
			state.MWSToken.Token &&
			state.MWSToken.ExpiredDate > new Date().getTime()
		);
	}
};
